export default __webpack_public_path__ + "static/media/HootGuard.f2b85fc4.jpg";